<div class="learning-camp-introduction-wrap" [ngClass]="{'open':!isClosePage,'close':isClosePage}">
<!--    <img src="{{assetsRoute}}/picture/camp/camp_start_1.png" alt="">-->
<!--    <img src="{{assetsRoute}}/picture/camp/camp_start_2.png" alt="">-->
<!--    <img src="{{assetsRoute}}/picture/camp/camp_start_3.png" alt="">-->
<!--    <img src="{{assetsRoute}}/picture/camp/camp_start_4.png" alt="">-->
<!--    <img src="{{assetsRoute}}/picture/camp/camp_start_5.png" alt="">-->
    <img src="{{assetsRoute}}/picture/camp/{{campId}}/camp_start_all.png" alt="">
<!--    <div class="introduction-bottom-btn" (click)="closeLearningCampIntroduction()">-->
<!--     开启{{campName}}训练营-->
<!--    </div>-->
<!--    <div style="height:.5rem"></div>-->
</div>
<div *ngIf="isShowCommonBtn" class="introduction-bottom-btn" (click)="closeLearningCampIntroduction()">
  开启{{campName}}{{version}}训练营
</div>
<div *ngIf="!isShowCommonBtn" class="common-back-btn-blue" [ngClass]="{'showCloseBtn':!isShowCommonBtn}" (click)="closeLearningCampIntroduction()"></div>



// WEBPACK FOOTER //
// ./src/app/learning-camp/camp-introduction/learning-camp-introduction.component.html